export const DATE_FORMAT_MAP = {
    date: {
        display: "DD/MM/YYYY",
        parse: undefined,
    },
    "datetime-local": {
        display: "DD/MM/YYYY h:mm a",
        parse: undefined,
    },
    time: {
        display: "h:mm a",
        parse: "HH:mm",
    },
};
//# sourceMappingURL=date.js.map